/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import dayjs from 'dayjs';
import { SurveyActionData } from '../model/surveyData';
import { DataPeriods } from '../types/universalTracker';
import { DATE, formatDate } from './date';

export const isSurveyIdValid = (id: string) => String(id).length === 24;

export const isAdmin = (
  { stakeholders: { stakeholder, verifier } }:
    { stakeholders: { stakeholder: string[], verifier: string[] } }, userId: string
) => {
  stakeholder.includes(userId) || verifier.includes(userId);
};

export const getFirstMonth = (month: number | undefined, period: DataPeriods) => {
  if (month === undefined) {
    return month;
  }

  return dayjs()
    .utc()
    .month(month)
    .subtract(period === DataPeriods.Yearly ? 11 : period === DataPeriods.Quarterly ? 2 : 1, 'months')
    .month();
}

export const getFirstYear = (month: number | undefined, year: number | undefined, period: DataPeriods) => {
  if (year === undefined || month === undefined) {
    return undefined;
  }
  const firstMonth = getFirstMonth(month, period);
  if (firstMonth !== undefined && firstMonth > month) {
    return year - 1;
  }

  return year;
}

export const getStartDate = (effectiveDate: string, period: DataPeriods) => {
  const endMonth = dayjs(effectiveDate).month();
  const endYear = dayjs(effectiveDate).year();

  const startMonth = getFirstMonth(endMonth, period) ?? endMonth;
  const startYear = getFirstYear(endMonth, endYear, period) ?? endYear;

  return dayjs().set('month', startMonth).set('year', startYear).toISOString();
}

interface SurveyNameProp {
  name?: SurveyActionData['name'];
  initiatives?: {
    name?: string;
  }[];
  effectiveDate: SurveyActionData['effectiveDate']
}

export const getSurveyName = (surveyData: SurveyNameProp): string => {
  const name = (surveyData.name ?? surveyData.initiatives?.[0].name) || '';
  const date = formatDate(surveyData.effectiveDate, DATE.YEAR_MONTH, true);
  return `${name} ${date}`;
}
